import styled from 'styled-components';

import { Button, List, Text } from '@gympass/yoga';

export const ItemListText = styled(Text.Small)`
  font-style: italic;
  color: ${({ theme }) => theme.yoga.colors.textDisabled};
  margin-top: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const ItemListTitle = styled(Text.Small)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const ItemListContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ItemListLinkButton = styled(Button.Link)`
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  line-height: ${({ theme }) => theme.yoga.lineHeights.small}px;
  color: ${({ theme }) => theme.yoga.colors.deepPurple};
  margin: 0 27px;
  white-space: nowrap;
`;

export const ItemList = styled(List.Item)`
  padding: 18px 25px 15px 25px;
`;
